import { _ } from '_core';

import { DraftParams } from './types';

export const validate = (params: DraftParams) => {
  if (_.isEmpty(params.histories)) return ['Histories is a required field.'];
  return [];
};
